/*eslint-disable*/
import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Grid,
  Typography,
  TextField,
  Divider,
  FormControl,
  Paper,
  Box
} from "@mui/material";
import { STYLES } from "config";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";

const MandateDetailsComponent = forwardRef((props, ref) => {
  const { data, setvalue } = props;
  const [state, setstate] = useState(data || {});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setstate(data || {});
  }, [data]);

  const validateField = (name, value) => {
    let error = "";

    if (name === "mandate_type" && !value) {
      error = "Mandate type is required";
    // } else if (name === "mandateStartDate" && !value) {
    //   error = "Start date is required";
    // } else if (name === "mandateEndDate" && !value) {
    //   error = "End date is required";
    // } else if (name === "mandate_reason_for_selling" && !value) {
    //   error = "Reason for selling is required";
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const updateData = (e) => {
    const { name, value } = e.target;
    validateField(name, value); // Validate on change

    const updatedState = { ...state, [name]: value };
    setstate(updatedState);
    setvalue(updatedState);
  };

  const handleDropdownChange = (name, value) => {
    const updatedState = { ...state, [name]: value };
    setstate(updatedState);
    setvalue(updatedState);
  };

  const inputStyle = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#003366"
      },
      "&:hover fieldset": {
        borderColor: "#003366"
      }
    }
  };

  const mandateTypes = [
    { value: "expired", label: "Expired" },
    { value: "sole", label: "Sole" },
    { value: "mls", label: "MLS" },
    { value: "open", label: "Open" },
    { value: "joint", label: "Shared" },
    { value: "referral", label: "Referral" },
    { value: "pln", label: "PLN" }
  ];

  // 🔥 Expose validation method to parent stepper
  useImperativeHandle(ref, () => ({
    isValidated() {
      const requiredFields = [
        { name: "typeOfMandate", value: state.typeOfMandate },
        // { name: "mandateStartDate", value: state.mandateStartDate },
        // { name: "mandateEndDate", value: state.mandateEndDate },
        // { name: "mandate_reason_for_selling", value: state.mandate_reason_for_selling }
      ];

      let isValid = true;
      const newErrors = {};

      requiredFields.forEach(({ name, value }) => {
        if (!value || (typeof value === "string" && value.trim() === "")) {
          newErrors[name] = `${getLabelByName(name)} is required`;
          isValid = false;
        }
      });

      setErrors(newErrors);
      return isValid;
    }
  }));

  // Helper to get readable label
  const getLabelByName = (fieldName) => {
    const labels = {
      typeOfMandate: "Mandate Type",
      // mandateStartDate: "Start Date",
      // mandateEndDate: "End Date",
      // mandate_reason_for_selling: "Reason for Selling"
    };
    return labels[fieldName] || fieldName;
  };

  return (
    <Paper elevation={5} sx={{ p: 3 }}>
      <Box sx={{ p: 2 }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{ color: STYLES.WEB_APP_FONT_CLR }}
        >
          Mandate Information
        </Typography>
        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Typography
          variant="body1"
          paragraph
          sx={{ color: STYLES.WEB_APP_FONT_CLR }}
        >
          This page is for the property owner to provide the necessary
          information about the mandate of the property. This information is
          used to ensure that the correct people are notified and that the
          property is marketed correctly.
        </Typography>

        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          {/* Mandate Type */}
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
            >
              Mandate Type: <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item size={10}>
            <FormControl fullWidth sx={inputStyle}>
              <CustomDropDownPicker
                name="typeOfMandate"
                value={state?.typeOfMandate.toLowerCase() || ""}
                onChange={(value) =>
                  handleDropdownChange("typeOfMandate", value)
                }
                options={mandateTypes}
                placeholder="Select Mandate Type"
                style={{
                  borderColor: errors.typeOfMandate ? "red" : "#003366",
                  color: STYLES.WEB_APP_FONT_CLR
                }}
                error={!!errors.typeOfMandate}
                helperText={errors.typeOfMandate}
              />
            </FormControl>
            {errors.typeOfMandate && (
              <Typography variant="caption" color="error" sx={{ ml: 2 }}>
                {errors.typeOfMandate}
              </Typography>
            )}
          </Grid>

          {/* Mandate Start Date */}
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
            >
              Mandate Start 
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              size="small"
              fullWidth
              type="date"
              name="mandateStartDate"
              value={state?.mandateStartDate || ""}
              onChange={updateData}
              error={!!errors.mandateStartDate}
              helperText={errors.mandateStartDate}
              sx={inputStyle}
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>

          {/* Mandate End Date */}
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
            >
              Mandate End 
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              size="small"
              fullWidth
              type="date"
              name="mandateEndDate"
              value={state?.mandateEndDate || ""}
              onChange={updateData}
              error={!!errors.mandateEndDate}
              helperText={errors.mandateEndDate}
              sx={inputStyle}
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>

          {/* Reason for Selling */}
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
            >
              Reason for Selling 
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              multiline
              rows={4}
              name="mandate_reason_for_selling"
              value={state?.mandate_reason_for_selling || ""}
              onChange={updateData}
              error={!!errors.mandate_reason_for_selling}
              helperText={errors.mandate_reason_for_selling}
              sx={inputStyle}
            />
          </Grid>

          {/* Mandate Notes */}
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
            >
              Mandate Notes
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              multiline
              rows={4}
              name="mandate_notes"
              value={state?.mandate_notes || ""}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
});

export default MandateDetailsComponent;